import { ServiceCounter } from "@/services/service-counters/types";
import { useTranslations } from "next-intl";

export const BalcaoBUPI = ({
  name,
  address,
  contact,
  //district,
  municipality,
  email,
}: ServiceCounter) => {
  const t = useTranslations("ServiceCountList");

  return (
    <article
      className="border-b-2 border-neutral-200 pb-32"
      aria-labelledby="camara-titulo"
    >
      <header>
        <div className="text-primary-600 text-s-regular font-normal">
          {t("balcaoBUPI")}
        </div>
        <h2 className="py-8 text-xl-bold text-neutral-900">
          {name}
        </h2>
      </header>

      <div className="mb-4">
        <dl className="grid gap-1">
          <div className="flex gap-8">
            <dt className="font-semibold text-neutral-900">
              {t("municipality")}
            </dt>
            <dd className="ml-1 text-m-regular text-neutral-900">
              {municipality}
            </dd>
          </div>

          <div className="flex gap-8">
            <dt className="font-semibold text-neutral-900">
              {t("household")}
            </dt>
            <dd className="ml-1 text-m-regular text-neutral-900">{address}</dd>
          </div>

          {/* <div className="text-gray-700 mb-4">{district}</div> */}
        </dl>
      </div>

      <div className="flex flex-col md:flex-row mt-8 flex-wrap gap-0 md:gap-32">
        <a
          href={`tel:${contact}`}
          className="flex items-center py-8 text-primary-600 text-m-semibold gap-8"
          aria-label={`Ligar para ${contact}`}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_3530_35960)">
              <path
                d="M15 12H17C17 9.24 14.76 7 12 7V9C13.66 9 15 10.34 15 12ZM19 12H21C21 7.03 16.97 3 12 3V5C15.87 5 19 8.13 19 12ZM20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.78L8.82 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.98 7.58L5.78 8.79C5.38 7.58 5.12 6.32 5.03 5ZM19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.97Z"
                fill="#0E8668"
              />
            </g>
            <defs>
              <clipPath>
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>{contact}</span>
        </a>

        <a
          href={`mailto:${email}`}
          className="flex items-center py-8 text-primary-600 text-m-semibold gap-8"
          aria-label="Enviar email"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 3C2.34772 3 1 4.34772 1 6V18C1 19.6523 2.34772 21 4 21H20C21.6523 21 23 19.6523 23 18V6C23 4.34772 21.6523 3 20 3H4ZM3.10657 5.55397C3.27194 5.22693 3.61203 5 4 5H20C20.388 5 20.7281 5.22693 20.8934 5.55396L12 11.7794L3.10657 5.55397ZM3 7.92068V18C3 18.5477 3.45228 19 4 19H20C20.5477 19 21 18.5477 21 18V7.92068L12.5735 13.8193C12.2291 14.0603 11.7709 14.0603 11.4265 13.8193L3 7.92068Z"
              fill="#0E8668"
            />
          </svg>

          <span>{email}</span>
        </a>
      </div>
    </article>
  );
};
